//import enProjectMessages from '../locales/zakaut/en_US.json';
import enCommonMessages from "../locales/en_US.json";

const enProjectMessages = require(`../locales/${process.env.REACT_APP_PROJECT}/en_US.json`);

let EnLang = {
    messages: {
        ...enCommonMessages,
        ...enProjectMessages,
    },
    locale: "en-US",
};

if (process.env.REACT_APP_PROJECT === "taxi") {
    const enCustomersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Customers/locales/en_US.json`);
    const enLimitsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Limits/locales/en_US.json`);
    const enCustomersReportsMessages = require(
        `${process.env.REACT_APP_MODULES_DIR}/CustomersReports/locales/en_US.json`,
    );
    const enTariffsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Tariffs/locales/en_US.json`);
    const enCitiesMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Cities/locales/en_US.json`);
    const enCoordinatorsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Coordinators/locales/en_US.json`);
    const enProvidersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Providers/locales/en_US.json`);
    const enEmployeesMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Employees/locales/en_US.json`);
    const enHelpRequestsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/HelpRequests/locales/en_US.json`);
    const enOrdersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Orders/locales/en_US.json`);
    const enManagersMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Managers/locales/en_US.json`);
    const enAccessTokensMessages = require(`${process.env.REACT_APP_MODULES_DIR}/AccessTokens/locales/en_US.json`);
    const enAdminsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Admins/locales/en_US.json`);
    const enRolesMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Roles/locales/en_US.json`);
    const enAuthMessages = require(`modules/Auth/locales/en_US.json`);
    const enUsersMessages = require(`modules/Users/locales/en_US.json`);
    const enAnalyticsMessages = require(`${process.env.REACT_APP_MODULES_DIR}/Analytics/locales/en_US.json`);

    EnLang = {
        messages: {
            ...enCommonMessages,
            ...enProjectMessages,
            ...enAnalyticsMessages,
            ...enCustomersMessages,
            ...enLimitsMessages,
            ...enCustomersReportsMessages,
            ...enCoordinatorsMessages,
            ...enProvidersMessages,
            ...enTariffsMessages,
            ...enCitiesMessages,
            ...enEmployeesMessages,
            ...enOrdersMessages,
            ...enHelpRequestsMessages,
            ...enAdminsMessages,
            ...enManagersMessages,
            ...enAccessTokensMessages,
            ...enRolesMessages,
            ...enAuthMessages,
            ...enUsersMessages,
        },
        locale: "en-US",
    };
}
export default EnLang;
